import { render, staticRenderFns } from "./dayBillPosTab.vue?vue&type=template&id=3c522418&scoped=true&"
import script from "./dayBillPosTab.vue?vue&type=script&lang=js&"
export * from "./dayBillPosTab.vue?vue&type=script&lang=js&"
import style0 from "./dayBillPosTab.vue?vue&type=style&index=0&id=3c522418&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c522418",
  null
  
)

export default component.exports